import { useEffect } from "react";
import { useTranslation } from "next-i18next";
import BlogsComponent from "@/components/Blogs/BlogsComponent";
import useGeneralStore from "@/store/General/useGeneralStore";

const News = () => {
  const { i18n } = useTranslation("common");
  const currentLang = i18n.language || "en";
  const { fetchBlogsComponent } = useGeneralStore((state) => ({
    fetchBlogsComponent: state.fetchBlogsComponent,
  }));

  useEffect(() => {
    fetchBlogsComponent();
  }, [fetchBlogsComponent, currentLang]);

  return <BlogsComponent />;
};

export default News;
